export default "__VITE_ASSET__4bf8feec__"